import { View } from "react-native";
import TouchableWithoutFeedback from "src/components/TouchableWithoutFeedback";
import usePalette from "src/hooks/usePalette";
import { Image } from "src/swsh-native";
import { CommentSmallImageHeight, ContentSmallImageVerticalOffset } from "../constants";
import { CommentAttachmentType, CommentBubbleProps } from "../types";

const CommentSmallImageWidth = 50;
const CommentSmallImagePadding = 3;
const CommentSmallImageRadius = 8;
const ContentSmallImageHorizontalOffset = -0.6 * CommentSmallImageWidth;

const CommentAttachmentSmallImage = ({
	attachment,
	sender,
}: {
	attachment: CommentAttachmentType.SmallImage;
	sender: NonNullable<CommentBubbleProps["sender"]>;
}) => {
	const { primary, isFallback } = usePalette();

	return (
		<View
			style={[
				{
					position: "absolute",
					backgroundColor: isFallback ? "#FFFFFF" : primary,
					width: CommentSmallImageWidth,
					height: CommentSmallImageHeight,
					borderRadius: CommentSmallImageRadius,
					opacity: 0.6,
					padding: CommentSmallImagePadding,
				},
				sender === "Other" && {
					top: ContentSmallImageVerticalOffset,
					right: ContentSmallImageHorizontalOffset,
					transform: [
						{
							rotate: "8deg",
						},
					],
				},
				sender === "Self" && {
					top: ContentSmallImageVerticalOffset,
					left: ContentSmallImageHorizontalOffset,
					transform: [
						{
							rotate: "-8deg",
						},
					],
				},
			]}
		>
			<TouchableWithoutFeedback onPress={attachment.onPress}>
				<Image
					alt="Comment Image Thread"
					dim={{
						width: CommentSmallImageWidth - 2 * CommentSmallImagePadding,
						height: CommentSmallImageHeight - 2 * CommentSmallImagePadding,
					}}
					style={{
						borderRadius: CommentSmallImageRadius - CommentSmallImagePadding / 2,
					}}
					src={attachment.imageUrl}
				/>
			</TouchableWithoutFeedback>
		</View>
	);
};

export default CommentAttachmentSmallImage;
